export function createFukushizaiPanelDisplayService(deps) {
    // ブランドネーム等の例外パネルは context 不完全でも空行表示を許容します。
    function canRenderIncompleteContextPanel(panelInfo) {
        return deps.isBrandNamePanelInfo(panelInfo)
            || deps.isOtherNamePanelInfo(panelInfo)
            || deps.isOtherFukuzaiPanelInfo(panelInfo);
    }

    // 副資材の補助表示行を panel 種別ごとに整形します。
    function decorateFukushizaiSupplementDisplayRows(panelInfo, rows, contextOverride = null) {
        let nextRows = Array.isArray(rows) ? rows : [];
        const buildContext = deps.normalizeFukushizaiContext(contextOverride);

        // 小物札はラベル読込を先に要求してから表示行を整形します。
        if (deps.isKomonofudaPanelInfo(panelInfo)) {
            deps.requestKomonoFudaLabelsForRow(Array.isArray(nextRows) ? nextRows.find((row) => !deps.isEmpty(row)) : null);
            nextRows = deps.buildKomonoFudaDisplayRows(nextRows, buildContext);
        }

        // ブランドネーム表示を組み立てます。
        if (deps.isBrandNamePanelInfo(panelInfo)) {
            nextRows = deps.buildBrandNameDisplayRows(nextRows, buildContext);
        }

        // その他ネーム表示を組み立てます。
        if (deps.isOtherNamePanelInfo(panelInfo)) {
            nextRows = deps.buildOtherNameDisplayRows(nextRows, buildContext);
        }

        // その他副資材表示を組み立てます。
        if (deps.isOtherFukuzaiPanelInfo(panelInfo)) {
            nextRows = deps.buildOtherFukuzaiDisplayRows(nextRows, buildContext);
        }

        return nextRows;
    }

    // 副資材 context 表示パネル向けの代表行を組み立てます。
    function buildFukushizaiContextDisplayRows(panelInfo, detailData, previewOverride = undefined, contextOverride = null) {
        const buildContext = deps.normalizeFukushizaiContext(contextOverride);
        const previewRows = deps.getActiveFukushizaiCopyPreviewRows(previewOverride, buildContext);
        const sourceRows = previewRows.length !== 0
            ? previewRows
            : deps.getDetailRowsByPanelType(detailData, deps.FUKUSHIZAI_BASE_PANEL_TYPE);
        const picked = deps.pickFukushizaiRepresentativeRow(sourceRows, buildContext, false);
        const selectedRow = deps.isEmpty(picked?.row)
            ? deps.createFukushizaiEmptyRow(buildContext, "0")
            : picked.row;

        // context を持てない通常パネルは描画対象外とします。
        if (
            deps.isEmpty(selectedRow)
            || (
                !deps.hasCompleteFukushizaiContext(deps.readFukushizaiContextFromRow(selectedRow))
                && !canRenderIncompleteContextPanel(panelInfo)
            )
        ) {
            return [];
        }

        return decorateFukushizaiSupplementDisplayRows(panelInfo, [selectedRow], buildContext);
    }

    return {
        buildFukushizaiContextDisplayRows,
        decorateFukushizaiSupplementDisplayRows
    };
}
